import { Page, Tabs } from '@shopify/polaris';
import { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import './index.scss';
import Langauge from '../../i18n/Language';
import { store } from '../../redux/store';
import { cloneDeep } from 'lodash-es';
import { setReduxInitTabsState } from '../../redux/actions/getAppPublicData';
import ToastFunc from '../ToastFunc';
const t = Langauge;

const TabsPublicBlock = (props) => {
    const {
        location,
    } = props;

    const isShopify = window.shopify;

    // toast 状态用 useState 驱动重渲染；key 用于强制重挂载 ToastFunc，重置其内部 active
    const [toast, setToast] = useState({
        show: false,
        text: "",
        isError: false,
        key: 0,
    });
    const toastTimerRef = useRef(null);

    useEffect(() => {
        // amp 下架状态兼容
        const unsubscribe = store.subscribe(() => {
            let _public = store.getState().public;
            let _others = _public.homeStreamData.other_options || {};
            if (Object.keys(_others).length > 0 && !_public.initAmpTabsState) {
                store.dispatch(setReduxInitTabsState({ type: 'tabs' }));
                if (!Boolean(_others?.amp_any_page_enabled)) {
                    // 去掉amp（用 filter 生成干净数组，避免稀疏空洞）
                    let newTabs = cloneDeep(TabsContanier);
                    newTabs["Speed Optimization"] = newTabs["Speed Optimization"].filter(item => item.id !== 'sp_3');
                    setTabsData(newTabs);
                }
            }
        });
        return () => {
            unsubscribe();
        };
    }, []);

    // tab数组
    const TabsContanier = {
        "Speed Optimization": [
            {
                id: 'sp_1',
                content: t("Site Speed Up"),
                url: "/speedOpt/site-speedup"
            },
            {
                id: 'sp_2',
                content: t("Image Optimization"),
                url: "/speedOpt/PageSpeed"
            },
            {
                id: 'sp_3',
                content: t("AMP"),
                url: "/speedOpt/seo-ant-amp"
            }
        ],
        "AI Content Creation": [
            {
                id: 'cs_1',
                content: t("AI Content Planner"),
                url: "/content-seo/keyword-content-planner"
            },
            {
                id: 'cs_2',
                content: t("AI Blog Generator"),
                url: "/content-seo/ai-blog-generator"
            }
        ],
        "Content Optimization": [
            {
                id: 'co_1',
                content: t("Content Audit & Optimizer"),
                url: "/on-page-seo/list"
            },
            {
                id: 'co_2',
                content: t("SEO Metadata"),
                url: "/on-page-seo/seo-metadata"
            }
        ],
        "Technical SEO": [
            {
                id: 'ts_1',
                content: t("Broken Link Redirects"),
                url: "/technicalSEO/broken-link/view-errors"
            },
            {
                id: 'ts_2',
                content: t("Structure Data"),
                url: "/technicalSEO/structured-data"
            },
            {
                id: 'ts_3',
                content: t("Crawling & Indexing"),
                url: "/technicalSEO/crawling-indexing"
            },
            {
                id: 'ts_4',
                content: t("Site Verification"),
                url: "/technicalSEO/site-verification"
            }
        ],
        "Keyword Research": [
            {
                id: 'kr_1',
                content: t("Keyword Rank Tracker"),
                url: "/keywordRearch/keywords-data"
            },
            {
                id: 'kr_2',
                content: t("Keyword Suggestions"),
                url: "/keywordRearch/keywords-search"
            },
            {
                id: 'kr_3',
                content: t("Competitor Analysis"),
                url: "/keywordRearch/keywords-monitor"
            },
            {
                id: 'kr_4',
                content: t("GSC Data Analysis"),
                url: "/keywordRearch/GoogleSearchConsoleV2"
            }
        ],
        "Link Building": [
            {
                id: 'lb_1',
                content: t("Exchange Backlink"),
                url: "/backlinks/exchange-backlink"
            },
            {
                id: 'lb_2',
                content: t("Backlink Audit"),
                url: "/backlinks/backlink-audit"
            }
        ]
    }

    const [tabsData, setTabsData] = useState(TabsContanier);

    // 在渲染期同步派生 tab 状态，避免用 useEffect 派生导致「先渲染旧值、effect 执行后再刷新」的闪烁
    const moreUrlObj = {
        "/speedOpt": "Speed Optimization",
        "/content-seo": "AI Content Creation",
        "/on-page-seo": "Content Optimization",
        "/technicalSEO": "Technical SEO",
        "/backlinks": "Link Building",
        "/keywordRearch": "Keyword Research",
    };
    const excludeObj = [
        "/speedOpt/PageSpeed/settings",      // 图片优化详情页
        "/speedOpt/PageSpeed/details",      // 图片优化详情页
        "/speedOpt/seo-ant-amp/custome",      // amp编辑页
        "/content-seo/keyword-content-planner/detail",   // 关键词内容规划器详情页
        "/on-page-seo/detail",   // on-page SEO详情页
        "/on-page-seo/content-edit",   // on-page SEO详情页
        "/on-page-seo/image-alt-text",   // image-alt-text详情页
        "/on-page-seo/bulk-edit/manual-bulk-edit",  // manual-bulk-edit详情页
        "/content-seo/ai-blog-generator/generate",   // generate-blog详情页

        "/technicalSEO/organization",   // organization详情页
        "/technicalSEO/local-business",   // local-business详情页
        "/technicalSEO/html-sitemap",   // html-sitemap详情页
        "/technicalSEO/instant-index",   // instant-index详情页
        "/technicalSEO/llms-txt",   // llms-txt详情页
        "/technicalSEO/structured-data/organization",   // structured-data/organization详情页
        "/technicalSEO/structured-data/product",   // structured-data/product详情页
        "/on-page-seo/image-alt-text/details",   // Alt/details详情页

        "/keywordRearch/keywords-gap",   // keywords-gap详情页
        "/keywordRearch/keywords-research/Competitor-keywords-detail",   // Competitor-keywords-detail详情页
    ];
    const currentPathname = location.pathname;
    const currentObj = Object.keys(moreUrlObj).find(i => currentPathname.includes(i) && !excludeObj.includes(currentPathname));
    const useTabsTitle = currentObj ? moreUrlObj[currentObj] : "";
    const currentTabArr = (useTabsTitle ? tabsData[useTabsTitle] : []).map(item => ({
        id: item.id,
        value: item.content,
        content: t(item.content),
    }));
    let tabIndex = 0;
    if (useTabsTitle) {
        (tabsData[useTabsTitle] || []).forEach((tabItem, index) => {
            if (currentPathname.includes(tabItem.url)) {
                tabIndex = index;
            }
        });
    }
    const tabState = Boolean(currentObj);

    // 提示弹窗：重复点击时先关掉上一个，再重新弹出
    const toggleToast = (showToastText, showToastIserror) => {
        if (toastTimerRef.current) {
            clearTimeout(toastTimerRef.current);
            toastTimerRef.current = null;
        }

        setToast((prev) => ({ ...prev, show: false }));

        toastTimerRef.current = setTimeout(() => {
            setToast((prev) => ({
                show: true,
                text: showToastText,
                isError: showToastIserror,
                key: prev.key + 1,
            }));
            toastTimerRef.current = null;
        }, 50);
    };

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) {
                clearTimeout(toastTimerRef.current);
                toastTimerRef.current = null;
            }
        };
    }, []);

    // 点击跳转
    const handleTabClick = (e) => {
        const _url = tabsData[useTabsTitle][e]?.url || '';
        // 如果 url 为空，则提示
        if (!_url) {
            toggleToast(t("Feature Removed, Refresh"), true);
        } else {
            if (!Boolean(window.savebarState)) {
                const url = location.pathname;
                if (url.indexOf(_url) === -1) {
                    props.history.push(_url);
                }
            } else {
                if (isShopify) {
                    isShopify.saveBar.leaveConfirmation();
                } else {
                    toggleToast(t("Data not saved"));
                }
            }
        }

    };

    const toastMarkup = toast.show ? (
        <ToastFunc
            key={toast.key}
            content={toast.text}
            onDismiss={true}
            error={toast.isError}
        />
    ) : null;

    // 最终内容
    const tabContent = tabState ? <Page
        title={useTabsTitle ? t(useTabsTitle) : null}
    >
        <div className='btn_tabs_block'>
            <Tabs
                tabs={currentTabArr}
                selected={tabIndex}
                onSelect={handleTabClick}
            ></Tabs>
        </div>
        {toastMarkup}
    </Page> : null;

    return tabContent;
};

export default withRouter(TabsPublicBlock);